import { useLang } from "@/lib/i18n";

export const LanguageToggle = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  return (
    <div role="group" aria-label="Language" className={`inline-flex rounded-full border border-hacienda-border-dark p-0.5 text-xs font-semibold ${className}`} data-testid="language-toggle">
      {["en", "es"].map((code) => (
        <button
          key={code}
          type="button"
          onClick={() => setLang(code)}
          aria-pressed={lang === code}
          lang={code}
          className={`px-3 py-1 rounded-full transition-colors ${lang === code ? "bg-hacienda-charcoal text-white" : "text-hacienda-gray hover:text-hacienda-charcoal"}`}
          data-testid={`lang-${code}`}
        >
          {code === "en" ? "EN" : "ES"}
        </button>
      ))}
    </div>
  );
};
